import type { components } from '@connected/api-client/api.generated';

import { File } from '@connected/ui/components/file';
import { useMemo } from 'react';

import { useElectricalProjectFileDownload } from '@/hooks/use-electrical-project-file-download';
import { useElectricalProjectFiles } from '@/hooks/use-electrical-project-files';

export function ElectricalProjectFilePreview({ electricalProjectFileId, quality = 'OriginalWebp' }: { electricalProjectFileId: string; quality?: components['schemas']['ImageQuality'] }) {
    const { getElectricalProjectFile } = useElectricalProjectFiles();

    const file = useMemo(() => getElectricalProjectFile(electricalProjectFileId), [electricalProjectFileId, getElectricalProjectFile]);

    const download = useElectricalProjectFileDownload({ query: {
        ElectricalProjectFileId: electricalProjectFileId,
        FileId: file?.File?.FileId,
        ImageQuality: quality,
    } });

    if (download.isError) {
        return (
            <em className="text-red-500 text-sm">
                {download.error?.message || 'Er is iets misgegaan'}
            </em>
        );
    }

    return (
        <>
            <File file={download.file} disabled={download.isLoading} />
        </>
    );
}
